module.exports = __webpack_public_path__ + "static/media/RightArt2x.eeea97fd.png";